import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {AuthService} from "./auth.service";

@Injectable()
export class AccessGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // console.log('canActivate');
        // console.log(next.url);
        if (this.authService.isLoggedIn()) {
            return true;
        }else {
            this.router.navigate(['login']);
            return false;
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot,
                     state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // console.log('canActivateChild');
        // console.log(route.pathFromRoot);
        return true;
    }
}
/*

 import { Injectable }       from '@angular/core';
 import {
 CanActivate, Router,
 ActivatedRouteSnapshot,
 RouterStateSnapshot,
 CanActivateChild
 }                           from '@angular/router';
 import { AuthService }      from './auth.service';

 @Injectable()
 export class AuthGuard implements CanActivate, CanActivateChild {
 constructor(private authService: AuthService, private router: Router) {}

 canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
 let url: string = state.url;

 return this.checkLogin(url);
 }

 canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
 return this.canActivate(route, state);
 }

 checkLogin(url: string): boolean {
 if (this.authService.isLoggedIn) { return true; }

 // Store the attempted URL for redirecting
 this.authService.redirectUrl = url;

 // Navigate to the login page
 this.router.navigate(['/login']);
 return false;
 }
 }

 */


// WEBPACK FOOTER //
// ./src/app/core/security/access.guard.ts